import { Chip } from '@mui/material'
import React from 'react'
import { STATES_CMS } from '../../../../events/constants/CMSEventConstants'

const ERROR = 'ERREUR'
const SENT = 'ENVOYE'
const IN_PROGRESS = 'EN COURS'
const NO_INFORMATION = 'AUCUNE INFORMATION'

const OPTIONS = [
    { label: IN_PROGRESS, theme: 'warningStatus' },
    { label: SENT, theme: 'validStatus' },
    { label: ERROR, theme: 'errorStatus' },
    { label: NO_INFORMATION, theme: '' },
]

const IconStatusCms = (s) => {
    const status = OPTIONS.find(sm => (sm.label === s))
    return (
        <Chip
            label={status?.label}
            color={status?.theme}
            size={'small'}
        />
    )
}
const getStatusCms = (s) => {
    switch (s) {
        case STATES_CMS.SENT:
        case STATES_CMS.DELIVERED:
            return SENT
        case STATES_CMS.QUEUED:
        case STATES_CMS.QUEUED_WAIT_SEND:
            return IN_PROGRESS
        case STATES_CMS.BOUNCE:
            return ERROR
        default:
            return s
    }
}

export {
    IconStatusCms,
    getStatusCms,
}